import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  ScrollView,
  Image,
  TouchableOpacity,
  Slider,
  useColorScheme,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { PieChart } from 'react-native-chart-kit';
import { Dimensions } from 'react-native';

// 从搜索页面引入模拟数据
const mockFoodData = [
  {
    id: '1',
    name: '米饭',
    pinyin: 'mifan',
    category: '谷物类',
    subcategory: '主食',
    nutrients: { 
      calories: 116, 
      protein: 2.6, 
      carbs: 25.6, 
      fat: 0.3,
      fiber: 0.4,
      sugar: 0.1,
      sodium: 5,
      potassium: 28,
      vitaminA: 0,
      vitaminC: 0,
      calcium: 3,
      iron: 0.2
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 100, unit: '克' },
    description: '米饭是中国人的主食之一，由大米蒸煮而成，富含碳水化合物，是能量的重要来源。'
  },
  {
    id: '2',
    name: '全麦面包',
    pinyin: 'quanmaimianbao',
    category: '谷物类',
    subcategory: '主食',
    nutrients: { 
      calories: 265, 
      protein: 9.0, 
      carbs: 49.0, 
      fat: 3.2,
      fiber: 7.0,
      sugar: 6.0,
      sodium: 450,
      potassium: 220,
      vitaminA: 0,
      vitaminC: 0,
      calcium: 50,
      iron: 3.0
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 100, unit: '克' },
    description: '全麦面包由全麦面粉制成，保留了麦麸和胚芽，富含膳食纤维、B族维生素和矿物质。'
  },
  {
    id: '3',
    name: '鸡胸肉',
    pinyin: 'jixiongrou',
    category: '肉类',
    subcategory: '禽肉',
    nutrients: { 
      calories: 165, 
      protein: 31.0, 
      carbs: 0, 
      fat: 3.6,
      fiber: 0,
      sugar: 0,
      sodium: 74,
      potassium: 256,
      vitaminA: 6,
      vitaminC: 0,
      calcium: 15,
      iron: 1.0
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 100, unit: '克' },
    description: '鸡胸肉是高蛋白低脂肪的优质蛋白质来源，富含B族维生素和矿物质，是健身人士的首选。'
  },
  {
    id: '4',
    name: '三文鱼',
    pinyin: 'sanwenyu',
    category: '海鲜类',
    subcategory: '鱼类',
    nutrients: { 
      calories: 206, 
      protein: 22.0, 
      carbs: 0, 
      fat: 13.0,
      fiber: 0,
      sugar: 0,
      sodium: 55,
      potassium: 380,
      vitaminA: 149,
      vitaminC: 3.9,
      calcium: 13,
      iron: 0.8
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 100, unit: '克' },
    description: '三文鱼富含优质蛋白质和欧米伽-3脂肪酸，对心脏健康和大脑发育有益。'
  },
  {
    id: '5',
    name: '西兰花',
    pinyin: 'xilanhua',
    category: '蔬菜类',
    subcategory: '十字花科蔬菜',
    nutrients: { 
      calories: 34, 
      protein: 2.8, 
      carbs: 6.6, 
      fat: 0.4,
      fiber: 2.6,
      sugar: 1.7,
      sodium: 33,
      potassium: 316,
      vitaminA: 623,
      vitaminC: 89.2,
      calcium: 47,
      iron: 0.7
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 100, unit: '克' },
    description: '西兰花是十字花科蔬菜，富含维生素C、K和膳食纤维，具有抗氧化和抗炎特性。'
  },
  {
    id: '6',
    name: '苹果',
    pinyin: 'pingguo',
    category: '水果类',
    subcategory: '仁果类',
    nutrients: { 
      calories: 52, 
      protein: 0.3, 
      carbs: 13.8, 
      fat: 0.2,
      fiber: 2.4,
      sugar: 10.4,
      sodium: 1,
      potassium: 107,
      vitaminA: 54,
      vitaminC: 4.6,
      calcium: 6,
      iron: 0.1
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 100, unit: '克' },
    description: '苹果富含膳食纤维、抗氧化物和维生素C，有助于消化健康，被称为"每天一苹果，医生远离我"。'
  },
  {
    id: '7',
    name: '牛奶',
    pinyin: 'niunai',
    category: '乳制品',
    subcategory: '液态奶',
    nutrients: { 
      calories: 42, 
      protein: 3.4, 
      carbs: 5.0, 
      fat: 1.0,
      fiber: 0,
      sugar: 5.0,
      sodium: 44,
      potassium: 150,
      vitaminA: 68,
      vitaminC: 0,
      calcium: 125,
      iron: 0.1
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 100, unit: '毫升' },
    description: '牛奶是钙、维生素D和优质蛋白质的良好来源，对骨骼健康和肌肉生长至关重要。'
  },
  {
    id: '8',
    name: '橄榄油',
    pinyin: 'ganlanyu',
    category: '油脂类',
    subcategory: '植物油',
    nutrients: { 
      calories: 884, 
      protein: 0, 
      carbs: 0, 
      fat: 100,
      fiber: 0,
      sugar: 0,
      sodium: 2,
      potassium: 1,
      vitaminA: 0,
      vitaminC: 0,
      calcium: 1,
      iron: 0.6
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 15, unit: '毫升' },
    description: '橄榄油富含单不饱和脂肪酸和抗氧化物，是地中海饮食的重要组成部分，对心脏健康有益。'
  },
  {
    id: '9',
    name: '巧克力',
    pinyin: 'qiaokeli',
    category: '零食饮料',
    subcategory: '甜点',
    nutrients: { 
      calories: 546, 
      protein: 4.9, 
      carbs: 61.0, 
      fat: 31.0,
      fiber: 7.0,
      sugar: 48.0,
      sodium: 24,
      potassium: 559,
      vitaminA: 0,
      vitaminC: 0,
      calcium: 56,
      iron: 8.0
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 100, unit: '克' },
    description: '巧克力由可可豆制成，含有抗氧化物和少量咖啡因，适量食用可提升心情和提供能量。'
  },
  {
    id: '10',
    name: '豆腐',
    pinyin: 'doufu',
    category: '蛋白质类',
    subcategory: '豆制品',
    nutrients: { 
      calories: 76, 
      protein: 8.1, 
      carbs: 1.9, 
      fat: 4.2,
      fiber: 0.3,
      sugar: 0.7,
      sodium: 7,
      potassium: 121,
      vitaminA: 0,
      vitaminC: 0.1,
      calcium: 350,
      iron: 5.4
    },
    imageUrl: 'https://via.placeholder.com/200',
    portion: { default: 100, unit: '克' },
    description: '豆腐是大豆制品，富含优质植物蛋白和异黄酮，是素食者的重要蛋白质来源。'
  },
];

const screenWidth = Dimensions.get('window').width;

const FoodDetailScreen = ({ route, navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';
  const { foodId } = route.params;
  const [food, setFood] = useState(null);
  const [isFavorite, setIsFavorite] = useState(false);
  const [portionAmount, setPortionAmount] = useState(100);
  const [similarFoods, setSimilarFoods] = useState([]);
  
  useEffect(() => {
    // 加载食物数据
    const selectedFood = mockFoodData.find(item => item.id === foodId);
    if (selectedFood) {
      setFood(selectedFood);
      setPortionAmount(selectedFood.portion.default);
      
      // 模拟查找类似食物
      const similar = mockFoodData
        .filter(item => 
          item.id !== foodId && 
          (item.category === selectedFood.category || 
           item.subcategory === selectedFood.subcategory)
        )
        .slice(0, 3);
      setSimilarFoods(similar);
      
      // 将此食物添加到最近查看
      // 在实际应用中，这应该存储在本地存储或数据库中
    }
  }, [foodId]);
  
  if (!food) {
    return (
      <View style={{ 
        flex: 1, 
        justifyContent: 'center', 
        alignItems: 'center',
        backgroundColor: isDarkMode ? '#8fa0c1' : '#ffffff',
      }}>
        <Text style={{ color: isDarkMode ? 'white' : '#1f2937' }}>加载中...</Text>
      </View>
    );
  }
  
  // 根据份量计算营养素含量
  const calculateNutrient = (nutrientValue) => {
    const ratio = portionAmount / food.portion.default;
    return (nutrientValue * ratio).toFixed(1);
  };
  
  // 计算宏量营养素百分比
  const calculateMacroPercentage = () => {
    const protein = parseFloat(calculateNutrient(food.nutrients.protein));
    const carbs = parseFloat(calculateNutrient(food.nutrients.carbs));
    const fat = parseFloat(calculateNutrient(food.nutrients.fat));
    const total = protein + carbs + fat;
    
    if (total === 0) return { protein: 0, carbs: 0, fat: 0 };
    
    return {
      protein: Math.round((protein / total) * 100),
      carbs: Math.round((carbs / total) * 100),
      fat: Math.round((fat / total) * 100),
    };
  };
  
  const macroPercentages = calculateMacroPercentage();
  
  // 营养素平衡建议
  const getNutritionAdvice = () => {
    if (macroPercentages.carbs > 70) {
      return "该食物碳水化合物含量较高，请注意适量摄入，搭配蛋白质食物食用更均衡。";
    } else if (macroPercentages.fat > 50) {
      return "该食物脂肪含量较高，建议少量食用，注意控制每日脂肪摄入总量。";
    } else if (macroPercentages.protein > 70) {
      return "该食物蛋白质含量丰富，适合增肌人群，搭配碳水化合物食物可提供更全面的营养。";
    } else if (macroPercentages.carbs > 40 && macroPercentages.protein > 30) {
      return "该食物碳水和蛋白质均衡，是较为理想的能量和营养来源。";
    } else {
      return "此食物营养结构较为平衡，可作为日常饮食的一部分。";
    }
  };
  
  // 营养饼图数据
  const chartData = [
    {
      name: "蛋白质",
      population: parseFloat(calculateNutrient(food.nutrients.protein)),
      color: "#3b82f6",
      legendFontColor: isDarkMode ? "#e0e0e0" : "#7e7e7e",
      legendFontSize: 13
    },
    {
      name: "碳水",
      population: parseFloat(calculateNutrient(food.nutrients.carbs)),
      color: "#10b981",
      legendFontColor: isDarkMode ? "#e0e0e0" : "#7e7e7e",
      legendFontSize: 13
    },
    {
      name: "脂肪",
      population: parseFloat(calculateNutrient(food.nutrients.fat)),
      color: "#f97316",
      legendFontColor: isDarkMode ? "#e0e0e0" : "#7e7e7e",
      legendFontSize: 13
    }
  ];
  
  const toggleFavorite = () => {
    setIsFavorite(!isFavorite);
    // 在实际应用中，应该将此状态保存到本地存储或数据库中
  };
  
  return (
    <ScrollView 
      style={{
        flex: 1,
        backgroundColor: isDarkMode ? '#8fa0c1' : '#ffffff',
      }}
      contentContainerStyle={{ padding: 16 }}
    >
      {/* 食物基本信息 */}
      <View style={{
        alignItems: 'center',
        marginBottom: 24,
      }}>
        <Image
          source={{ uri: food.imageUrl }}
          style={{
            width: 160,
            height: 160,
            borderRadius: 80,
            marginBottom: 16,
          }}
        />
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <Text style={{
            fontSize: 24,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginRight: 8,
          }}>
            {food.name}
          </Text>
          <TouchableOpacity onPress={toggleFavorite}>
            <Ionicons
              name={isFavorite ? "heart" : "heart-outline"}
              size={28}
              color={isFavorite ? "#ec4899" : (isDarkMode ? "white" : "#9ca3af")}
            />
          </TouchableOpacity>
        </View>
        <Text style={{
          fontSize: 16,
          color: isDarkMode ? '#e0e0e0' : '#6b7280',
          marginTop: 4,
        }}>
          {food.category} | {food.subcategory}
        </Text>
      </View>
      
      {/* 份量调整 */}
      <View style={{
        backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
        padding: 16,
        borderRadius: 12,
        marginBottom: 24,
      }}>
        <Text style={{
          fontSize: 18,
          fontWeight: 'bold',
          marginBottom: 16,
          color: isDarkMode ? 'white' : '#1f2937',
        }}>
          份量调整
        </Text>
        <View style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 8,
        }}>
          <Text style={{
            fontSize: 16,
            color: isDarkMode ? 'white' : '#4b5563',
          }}>
            {portionAmount} {food.portion.unit}
          </Text>
          <View style={{ flexDirection: 'row' }}>
            <TouchableOpacity
              onPress={() => setPortionAmount(Math.max(1, portionAmount - 10))}
              style={{
                width: 36,
                height: 36,
                borderRadius: 18,
                backgroundColor: '#2563eb',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 8,
              }}
            >
              <Ionicons name="remove" size={24} color="white" />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => setPortionAmount(portionAmount + 10)}
              style={{
                width: 36,
                height: 36,
                borderRadius: 18,
                backgroundColor: '#2563eb',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Ionicons name="add" size={24} color="white" />
            </TouchableOpacity>
          </View>
        </View>
        <Slider
          value={portionAmount}
          minimumValue={1}
          maximumValue={500}
          step={1}
          onValueChange={setPortionAmount}
          minimumTrackTintColor="#2563eb"
          maximumTrackTintColor={isDarkMode ? '#7284a8' : '#d1d5db'}
          thumbTintColor="#2563eb"
        />
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <Text style={{ color: isDarkMode ? '#e0e0e0' : '#6b7280' }}>1 {food.portion.unit}</Text>
          <Text style={{ color: isDarkMode ? '#e0e0e0' : '#6b7280' }}>500 {food.portion.unit}</Text>
        </View>
      </View>
      
      {/* 营养成分可视化 */}
      <View style={{
        backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
        padding: 16,
        borderRadius: 12,
        marginBottom: 24,
      }}>
        <Text style={{
          fontSize: 18,
          fontWeight: 'bold',
          marginBottom: 8,
          color: isDarkMode ? 'white' : '#1f2937',
        }}>
          营养成分
        </Text>
        <Text style={{
          fontSize: 24,
          fontWeight: 'bold',
          marginBottom: 16,
          color: isDarkMode ? '#f8fafc' : '#0f172a',
          textAlign: 'center',
        }}>
          {calculateNutrient(food.nutrients.calories)} 千卡
        </Text>
        
        {/* 营养素比例饼图 */}
        <View style={{ alignItems: 'center', marginBottom: 20 }}>
          <PieChart
            data={chartData}
            width={screenWidth - 64}
            height={200}
            chartConfig={{
              backgroundGradientFrom: isDarkMode ? '#a9b6d0' : '#ffffff',
              backgroundGradientTo: isDarkMode ? '#a9b6d0' : '#ffffff',
              color: (opacity = 1) => isDarkMode ? `rgba(255, 255, 255, ${opacity})` : `rgba(0, 0, 0, ${opacity})`,
            }}
            accessor="population"
            backgroundColor="transparent"
            paddingLeft="0"
            absolute
          />
        </View>
        
        {/* 宏量营养素详情 */}
        <View style={{ marginBottom: 16 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 }}>
            <Text style={{ fontSize: 16, color: isDarkMode ? 'white' : '#1f2937' }}>蛋白质</Text>
            <Text style={{ fontSize: 16, color: isDarkMode ? 'white' : '#1f2937' }}>
              {calculateNutrient(food.nutrients.protein)} 克 ({macroPercentages.protein}%)
            </Text>
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 }}>
            <Text style={{ fontSize: 16, color: isDarkMode ? 'white' : '#1f2937' }}>碳水化合物</Text>
            <Text style={{ fontSize: 16, color: isDarkMode ? 'white' : '#1f2937' }}>
              {calculateNutrient(food.nutrients.carbs)} 克 ({macroPercentages.carbs}%)
            </Text>
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8 }}>
            <Text style={{ fontSize: 16, color: isDarkMode ? 'white' : '#1f2937' }}>脂肪</Text>
            <Text style={{ fontSize: 16, color: isDarkMode ? 'white' : '#1f2937' }}>
              {calculateNutrient(food.nutrients.fat)} 克 ({macroPercentages.fat}%)
            </Text>
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={{ fontSize: 16, color: isDarkMode ? 'white' : '#1f2937' }}>膳食纤维</Text>
            <Text style={{ fontSize: 16, color: isDarkMode ? 'white' : '#1f2937' }}>
              {calculateNutrient(food.nutrients.fiber)} 克
            </Text>
          </View>
        </View>
        
        {/* 营养素平衡建议 */}
        <View style={{
          backgroundColor: isDarkMode ? '#7284a8' : '#e0f2fe',
          padding: 12,
          borderRadius: 8,
        }}>
          <Text style={{
            fontSize: 14,
            color: isDarkMode ? 'white' : '#0c4a6e',
            lineHeight: 20,
          }}>
            <Ionicons name="information-circle" size={18} color={isDarkMode ? 'white' : '#0284c7'} />
            {' '}{getNutritionAdvice()}
          </Text>
        </View>
      </View>
      
      {/* 食物描述 */}
      {food.description && (
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          padding: 16,
          borderRadius: 12,
          marginBottom: 24,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            marginBottom: 8,
            color: isDarkMode ? 'white' : '#1f2937',
          }}>
            食物介绍
          </Text>
          <Text style={{
            fontSize: 16,
            lineHeight: 24,
            color: isDarkMode ? 'white' : '#4b5563',
          }}>
            {food.description}
          </Text>
        </View>
      )}
      
      {/* 类似食物推荐 */}
      {similarFoods.length > 0 && (
        <View style={{
          backgroundColor: isDarkMode ? '#a9b6d0' : '#f0f9ff',
          padding: 16,
          borderRadius: 12,
        }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            marginBottom: 16,
            color: isDarkMode ? 'white' : '#1f2937',
          }}>
            类似食物推荐
          </Text>
          <View>
            {similarFoods.map((item) => (
              <TouchableOpacity
                key={item.id}
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  paddingVertical: 12,
                  borderBottomWidth: 1,
                  borderBottomColor: isDarkMode ? '#7284a8' : '#e5e7eb',
                }}
                onPress={() => navigation.replace('FoodDetail', { foodId: item.id })}
              >
                <Image
                  source={{ uri: item.imageUrl }}
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: 24,
                    marginRight: 16,
                  }}
                />
                <View style={{ flex: 1 }}>
                  <Text style={{
                    fontSize: 16,
                    fontWeight: '500',
                    color: isDarkMode ? 'white' : '#1f2937',
                  }}>
                    {item.name}
                  </Text>
                  <Text style={{
                    fontSize: 14,
                    color: isDarkMode ? '#e0e0e0' : '#6b7280',
                  }}>
                    {item.nutrients.calories} 千卡 / {item.portion.default}{item.portion.unit}
                  </Text>
                </View>
                <Ionicons name="chevron-forward" size={24} color={isDarkMode ? '#e0e0e0' : '#9ca3af'} />
              </TouchableOpacity>
            ))}
          </View>
        </View>
      )}
    </ScrollView>
  );
};

export default FoodDetailScreen;